const Inputmask = require('inputmask').default;
function isEqualObjects(baseObject, otherObject) {
    if (typeof baseObject !== 'object')
        throw new Error('property "baseObject" must be an Object');
    if (typeof otherObject !== 'object')
        throw new Error('property "otherObject" must be an Object');
    for (const key of Object.keys(baseObject)) {
        if (baseObject[key] !== otherObject[key])
            return false;
    }
    return true;
}
export default {
    install(Vue, options) {
        Vue.directive('textfield-mask', {
            bind(el, binding, vnode, oldVnode) {
                const inputs = el.getElementsByTagName('INPUT');
                let input = inputs[0];
                if (inputs.length > 1) {
                    input = inputs[inputs.length - 1];
                }
                new Inputmask(binding.value).mask(input);
            },
            componentUpdated(el, binding, vnode) {
                const inputs = el.getElementsByTagName('INPUT');
                let input = inputs[0];
                if (inputs.length > 1) {
                    input = inputs[inputs.length - 1];
                }
                if (typeof binding.value === 'object') {
                    if (!isEqualObjects(input.inputmask.userOptions, binding.value)) {
                        input.inputmask.remove();
                        new Inputmask(binding.value).mask(input);
                    }
                }
            }
        });
    }
};
